var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurnedMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.32812C6 4.71875 6.42188 4.25 7.03125 4.25H8.25L9.75 7.25L8.25 8.75L12 11.75L10.5 8.75L12.75 7.25L11.25 4.25H13.9219C14.5312 4.25 15 4.71875 15 5.32812V9.5C15 11.75 13.3594 13.625 11.25 13.9531V16.25H12.75C13.125 16.25 13.5 16.625 13.5 17C13.5 17.4219 13.125 17.75 12.75 17.75H8.25C7.82812 17.75 7.5 17.4219 7.5 17C7.5 16.625 7.82812 16.25 8.25 16.25H9.75V13.9531C7.59375 13.625 6 11.75 6 9.5V5.32812ZM0 3.5C0 1.85938 1.3125 0.5 3 0.5H18C19.6406 0.5 21 1.85938 21 3.5V18.5C21 20.1875 19.6406 21.5 18 21.5H3C1.3125 21.5 0 20.1875 0 18.5V3.5ZM2.25 3.5V18.5C2.25 18.9219 2.57812 19.25 3 19.25H18C18.375 19.25 18.75 18.9219 18.75 18.5V3.5C18.75 3.125 18.375 2.75 18 2.75H3C2.57812 2.75 2.25 3.125 2.25 3.5Z",
    fill: "#7468DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurnedMember);
export default __webpack_public_path__ + "static/media/churnedMember.619b2a96d7b5acd382f88e7ea3139faa.svg";
export { ForwardRef as ReactComponent };